import { createAction } from 'redux-actions';
import {
  SET_LOCALE,
  FETCH_TRANSLATIONS_REQUEST,
  FETCH_TRANSLATIONS_FAILURE,
  FETCH_TRANSLATIONS_SUCCESS,
  FETCH_SUPPORTED_LANGUAGES_REQUEST,
  FETCH_SUPPORTED_LANGUAGES_SUCCESS,
  FETCH_SUPPORTED_LANGUAGES_FAILURE,
  CLEAR_TRANSLATIONS,
} from './constants';

export const setLocale = createAction(SET_LOCALE);

export const fetchTranslationsRequest = createAction(FETCH_TRANSLATIONS_REQUEST);
export const fetchTranslationsSuccess = createAction(FETCH_TRANSLATIONS_SUCCESS);
export const fetchTranslationsFailure = createAction(FETCH_TRANSLATIONS_FAILURE);

export const fetchSupportedLanguagesRequest = createAction(FETCH_SUPPORTED_LANGUAGES_REQUEST);
export const fetchSupportedLanguagesSuccess = createAction(FETCH_SUPPORTED_LANGUAGES_SUCCESS);
export const fetchSupportedLanguagesFailure = createAction(FETCH_SUPPORTED_LANGUAGES_FAILURE);

export const toggleDefinitionMode = createAction(CLEAR_TRANSLATIONS);
